import Swiper from 'swiper'
import { Navigation, Pagination, Keyboard } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default ({ totalSlides = 0 } = {}) => ({
    swiper: null,
    zoom: false,
    currentSlide: 0,
    totalSlides: totalSlides,

    get isFirstSlide() { return this.currentSlide === 0 },
    get isLastSlide() { return this.currentSlide === this.totalSlides - 1 },

    init() {
        const swiperEl = this.$root.querySelector('.swiper')

        if (!swiperEl) {
            throw new Error('Swiper element not found')
        }

        this.$watch('zoom', (value) => {
            const wrapper = this.$root.querySelector('.swiper-wrapper')
            const images = wrapper.querySelectorAll('img')

            this.$nextTick(() => {
                document.body.classList.toggle('!overflow-hidden', value)

                images.forEach((image) => {
                    image.classList.toggle('!h-auto', value)
                })
            })
        })

        this.swiper = new Swiper(swiperEl, {
            modules: [Navigation, Pagination, Keyboard],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            slidesPerView: 1,
        })
    },
    scrollThumbIntoView(index) {
        const thumbList = this.$refs.thumbList
        if (!thumbList) return
        const thumb = thumbList.children[index]
        if (thumb) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    },
    desktopGoTo(index) {
        const slider = this.$refs.desktopSlider
        if (!slider) return
        slider.scrollTo({ left: index * slider.clientWidth, behavior: 'smooth' })
        this.currentSlide = index
        this.scrollThumbIntoView(index)
    },
    desktopNext() { if (!this.isLastSlide) this.desktopGoTo(this.currentSlide + 1) },
    desktopPrev() { if (!this.isFirstSlide) this.desktopGoTo(this.currentSlide - 1) },
    updateDesktopSlide() {
        const slider = this.$refs.desktopSlider
        if (!slider) return
        const index = Math.round(slider.scrollLeft / slider.clientWidth)
        this.currentSlide = index
        this.scrollThumbIntoView(index)
    },
    toggleDesktopZoom() {
        if (!this.zoom) {
            this.swiper.slideTo(this.currentSlide, 0)
        }
        this.$nextTick(() => { this.zoom = !this.zoom })
    },
    toggleZoom(imageIndex) {
        if (!this.zoom && imageIndex !== undefined) {
            this.swiper.slideTo(imageIndex)
        }

        this.$nextTick(() => {
            this.zoom = !this.zoom
        })
    },
})
